var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0af;}.cls-2{fill:#2e2c70;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 136.71,
  y: 105.89,
  width: 13.72,
  height: 13.72
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 115.08,
  y: 114.85,
  width: 13.72,
  height: 13.72,
  transform: "translate(-50.35 121.88) rotate(-45)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 106.13,
  y: 136.48,
  width: 13.72,
  height: 13.72,
  transform: "translate(-30.35 256.34) rotate(-90)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 115.1,
  y: 158.11,
  width: 13.72,
  height: 13.72,
  transform: "translate(91.55 367.86) rotate(-135)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 136.73,
  y: 167.06,
  width: 13.72,
  height: 13.72,
  transform: "translate(287.18 347.84) rotate(-180)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 158.35,
  y: 158.09,
  width: 13.72,
  height: 13.72,
  transform: "translate(398.68 164.77) rotate(135)"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 167.3,
  y: 136.46,
  width: 13.72,
  height: 13.72,
  transform: "translate(317.49 -30.84) rotate(90)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 158.34,
  y: 114.84,
  width: 13.72,
  height: 13.72,
  transform: "translate(134.44 -81.17) rotate(45)"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 138.94,
  y: 84.55,
  width: 9.25,
  height: 9.25
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 100.65,
  y: 100.42,
  width: 9.25,
  height: 9.25,
  transform: "translate(-43.45 105.21) rotate(-45)"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 84.8,
  y: 138.72,
  width: 9.25,
  height: 9.25,
  transform: "translate(-53.92 232.77) rotate(-90)"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 100.67,
  y: 177.01,
  width: 9.25,
  height: 9.25,
  transform: "translate(51.31 384.52) rotate(-135)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 138.96,
  y: 192.86,
  width: 9.25,
  height: 9.25,
  transform: "translate(287.18 394.98) rotate(-180)"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 177.25,
  y: 176.99,
  width: 9.25,
  height: 9.25,
  transform: "translate(438.91 181.44) rotate(135)"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 193.11,
  y: 138.7,
  width: 9.25,
  height: 9.25,
  transform: "translate(341.06 -54.41) rotate(90)"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 177.24,
  y: 100.41,
  width: 9.25,
  height: 9.25,
  transform: "translate(127.54 -97.83) rotate(45)"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 140.44,
  y: 71.43,
  width: 6.26,
  height: 6.26
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 118.05,
  y: 75.19,
  width: 6.26,
  height: 6.26,
  transform: "translate(-18.87 43.6) rotate(-18.95)"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 98.1,
  y: 86.02,
  width: 6.26,
  height: 6.26,
  transform: "translate(-33.41 80.99) rotate(-37.9)"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 82.75,
  y: 102.74,
  width: 6.26,
  height: 6.26,
  transform: "translate(-49.72 119.88) rotate(-56.85)"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 73.66,
  y: 123.54,
  width: 6.26,
  height: 6.26,
  transform: "translate(-64.84 170.03) rotate(-75.8)"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 71.82,
  y: 146.16,
  width: 6.26,
  height: 6.26,
  transform: "translate(-67.63 236.34) rotate(-94.75)"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 77.42,
  y: 168.16,
  width: 6.26,
  height: 6.26,
  transform: "translate(-43.92 313.88) rotate(-113.7)"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 89.86,
  y: 187.14,
  width: 6.26,
  height: 6.26,
  transform: "translate(16.04 387.57) rotate(-132.65)"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 107.79,
  y: 201.06,
  width: 6.26,
  height: 6.26,
  transform: "translate(111.37 436.55) rotate(-151.6)"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 129.27,
  y: 208.39,
  width: 6.26,
  height: 6.26,
  transform: "translate(228.27 441.91) rotate(-170.55)"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 151.97,
  y: 208.36,
  width: 6.26,
  height: 6.26,
  transform: "translate(342.97 394.48) rotate(170.5)"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 173.42,
  y: 200.96,
  width: 6.26,
  height: 6.26,
  transform: "translate(429.01 299.41) rotate(151.55)"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 191.31,
  y: 186.98,
  width: 6.26,
  height: 6.26,
  transform: "translate(466 175.67) rotate(132.6)"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 203.7,
  y: 167.96,
  width: 6.26,
  height: 6.26,
  transform: "translate(446.51 50.27) rotate(113.65)"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 209.23,
  y: 145.95,
  width: 6.26,
  height: 6.26,
  transform: "translate(378.33 -50.35) rotate(94.7)"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 207.32,
  y: 123.33,
  width: 6.26,
  height: 6.26,
  transform: "translate(281.21 -108.64) rotate(75.75)"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 198.16,
  y: 102.56,
  width: 6.26,
  height: 6.26,
  transform: "translate(179.51 -120.61) rotate(56.8)"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 182.76,
  y: 85.89,
  width: 6.26,
  height: 6.26,
  transform: "translate(93.73 -95.33) rotate(37.85)"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 162.77,
  y: 75.13,
  width: 6.26,
  height: 6.26,
  transform: "matrix(0.95, 0.32, -0.32, 0.95, 34.29, -49.52)"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 118.52,
  y: 93.88,
  width: 15.13,
  height: 15.12,
  transform: "translate(-29.38 56.5) rotate(-22.7)"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 94.02,
  y: 118.52,
  width: 15.13,
  height: 15.12,
  transform: "translate(-53.62 172.21) rotate(-67.7)"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 94.12,
  y: 153.27,
  width: 15.13,
  height: 15.12,
  transform: "translate(-7.46 316.7) rotate(-112.7)"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 118.76,
  y: 177.77,
  width: 15.13,
  height: 15.12,
  transform: "translate(172.87 404.74) rotate(-157.7)"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 153.51,
  y: 177.67,
  width: 15.13,
  height: 15.12,
  transform: "translate(381.15 293.96) rotate(157.3)"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 178.01,
  y: 153.02,
  width: 15.13,
  height: 15.12,
  transform: "translate(404.57 49.84) rotate(112.3)"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 177.91,
  y: 118.27,
  width: 15.13,
  height: 15.12,
  transform: "translate(230 -93.83) rotate(67.3)"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 153.26,
  y: 93.78,
  width: 15.13,
  height: 15.12,
  transform: "translate(50.49 -53.46) rotate(22.3)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M232.26,115.9v-.11c0-11.2,8.37-20.47,20-20.47,7.18,0,11.48,2.54,15.43,6.27l-3,3.28c-3.34-3.16-7.07-5.43-12.44-5.43-8.77,0-15.33,7.13-15.33,16.24v.11c0,9.16,6.62,16.34,15.33,16.34,5.43,0,9-2.09,12.78-5.71l2.94,2.88c-4.13,4.19-8.65,7-15.83,7C240.68,136.26,232.26,127.27,232.26,115.9Z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M270.93,121.1V121a15.24,15.24,0,0,1,30.48-.11V121a15.18,15.18,0,0,1-15.32,15.27A15,15,0,0,1,270.93,121.1Zm26,0V121c0-6.28-4.69-11.42-10.85-11.42-6.34,0-10.69,5.14-10.69,11.31V121c0,6.28,4.64,11.37,10.8,11.37C292.53,132.36,296.94,127.27,296.94,121.1Z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M308,94.3h4.35v41.28H308Z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M321.14,94.3h4.36v41.28h-4.36Z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M346.81,132.47a12.08,12.08,0,0,0,9.22-4.13l2.72,2.43a15.08,15.08,0,0,1-12.05,5.49c-8,0-14.59-6.16-14.59-15.27,0-8.48,5.94-15.27,14-15.27,8.65,0,13.62,6.9,13.62,15.5,0,.39,0,.85-.05,1.52H336.52C337.14,128.91,341.67,132.47,346.81,132.47Zm8.54-13.23c-.51-5.32-3.56-9.84-9.33-9.84-5,0-8.88,4.18-9.5,9.84Z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M365.36,140.67l2-3.39A18.67,18.67,0,0,0,378.59,141c6.45,0,10.63-3.56,10.63-10.4v-3.45c-2.54,3.39-6.1,6.16-11.48,6.16A13.52,13.52,0,0,1,364,119.63v-.11a13.58,13.58,0,0,1,13.74-13.8,13.74,13.74,0,0,1,11.43,5.88v-5.26h4.35v24.15c0,4.53-1.36,8-3.73,10.35-2.6,2.6-6.5,3.9-11.14,3.9A22.88,22.88,0,0,1,365.36,140.67Zm24-21.09v-.12c0-6-5.21-9.89-10.75-9.89s-10.12,3.84-10.12,9.84v.11a9.89,9.89,0,0,0,10.12,10C384.13,129.47,389.34,125.46,389.34,119.58Z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M414.44,132.47a12.1,12.1,0,0,0,9.22-4.13l2.71,2.43a15.06,15.06,0,0,1-12,5.49c-8,0-14.59-6.16-14.59-15.27,0-8.48,5.94-15.27,14-15.27,8.65,0,13.63,6.9,13.63,15.5,0,.39,0,.85-.06,1.52H404.15C404.77,128.91,409.29,132.47,414.44,132.47ZM423,119.24c-.51-5.32-3.56-9.84-9.33-9.84-5,0-8.88,4.18-9.5,9.84Z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M444.85,121.1V121a15.25,15.25,0,0,1,30.49-.11V121A15.19,15.19,0,0,1,460,136.26,15,15,0,0,1,444.85,121.1Zm26,0V121c0-6.28-4.7-11.42-10.86-11.42-6.33,0-10.69,5.14-10.69,11.31V121c0,6.28,4.64,11.37,10.8,11.37C466.46,132.36,470.87,127.27,470.87,121.1Z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M483.13,110.19h-4V106.4h4v-2.54c0-3.34.91-5.89,2.55-7.53A8.61,8.61,0,0,1,492,94.07a13.16,13.16,0,0,1,4.8.74V98.6a14.29,14.29,0,0,0-4.24-.74c-3.39,0-5.09,2-5.09,6.22v2.38h9.28v3.73h-9.22v25.39h-4.36Z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M233.16,152.48h16.17c9.45,0,15.16,5.6,15.16,13.69v.11c0,9.16-7.13,13.91-16,13.91h-6.62v11.88h-8.71Zm15.61,20c4.35,0,6.9-2.61,6.9-6v-.11c0-3.9-2.72-6-7.07-6h-6.73v12.11Z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M267.15,177.08V177c0-8.71,7-15.78,16.46-15.78s16.34,7,16.34,15.67V177c0,8.71-7,15.78-16.46,15.78S267.15,185.79,267.15,177.08Zm24.32,0V177c0-4.47-3.23-8.37-8-8.37-4.92,0-7.86,3.79-7.86,8.26V177c0,4.47,3.23,8.37,8,8.37C288.53,185.34,291.47,181.55,291.47,177.08Z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M305.43,150.79H314v41.28h-8.6Z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M321.15,150.79h9.05v7.63h-9.05Zm.23,11H330v30.31h-8.59Z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M335.45,177.08V177a15.57,15.57,0,0,1,15.89-15.78c5.72,0,9.28,1.92,12.11,5.09l-5.26,5.66c-1.92-2-3.85-3.34-6.9-3.34-4.3,0-7.35,3.79-7.35,8.26V177c0,4.64,3,8.37,7.69,8.37,2.88,0,4.86-1.24,6.95-3.22l5,5.09a15.28,15.28,0,0,1-12.39,5.54A15.48,15.48,0,0,1,335.45,177.08Z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M368.25,150.79h9.05v7.63h-9.05Zm.23,11h8.59v30.31h-8.59Z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M384,161.76h8.59v4.3c2-2.55,4.53-4.87,8.88-4.87,6.5,0,10.29,4.3,10.29,11.26v19.62H403.2V175.16c0-4.07-1.93-6.16-5.21-6.16s-5.37,2.09-5.37,6.16v16.91H384Z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M418.29,198.06l2.94-6.44a19.81,19.81,0,0,0,10.24,2.77c5.88,0,8.65-2.83,8.65-8.26v-1.47c-2.55,3.06-5.32,4.92-9.9,4.92-7.07,0-13.46-5.15-13.46-14.14v-.11c0-9.05,6.51-14.14,13.46-14.14a12.27,12.27,0,0,1,9.79,4.53v-4h8.59v23.47c0,5.43-1.3,9.38-3.84,11.93-2.83,2.83-7.19,4.07-13.07,4.07A28.71,28.71,0,0,1,418.29,198.06Zm21.83-22.62v-.11c0-4.13-3.22-7-7.41-7s-7.35,2.88-7.35,7v.11c0,4.19,3.17,7,7.35,7S440.12,179.57,440.12,175.44Z"
});

function SvgCoPMasterLogoRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 568.78 288.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CollegeofPolicing_MasterLogo_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoPMasterLogoRgb);
export default __webpack_public_path__ + "static/media/CoP_MasterLogo_RGB.81407524e964724fa0988099fa17df35.svg";
export { ForwardRef as ReactComponent };